import React from 'react'
import MaterialTable from '@material-table/core'
import { withTranslation } from 'react-i18next'
  import Icons from 'includes/Icons'
import EmptySettlement from './EmptySettlement'
import HeaderWithExportOptions from 'components/HeaderWithExportOptions'
import Filter from 'components/Filter'

export default withTranslation()(function SettlementTable({ t }) {

  return (
    <>
      {
        !transactions ? (
          <EmptySettlement />
        ) : (
          <MaterialTable
            columns={[
              { title: t('settlements.table.customer'), field: 'name' },
              { title: t('settlements.table.gross'), field: 'amount' },
              { title: t('settlements.table.net'), field: 'net' },
              {
                title: t('misc.status'),
                field: 'status',
                render: ({ status }) => <span className={`p-0.5 px-2 rounded-lg font-medium ${status === 'Pending' ? 'text-yellow-500 bg-yellow-500 bg-opacity-10' : 'text-green bg-success bg-opacity-10'}`}>{ status }</span>
              },
              { title: t('settlements.table.reference'), field: 'reference' },
              { title: t('settlements.table.method'), field: 'method' },
              { title: t('settlements.table.date'), field: 'date' }
            ]}
            actions={[
              {
                icon: 'save',
                tooltip: 'Save User',
              },
            ]}
            options={{
              actionsColumnIndex: -1
            }}
            icons={Icons}
            data={transactions}
            components={{
              Toolbar: props => (
                <HeaderWithExportOptions 
                  title={ t('settlements.table.details') }
                  exportOptions={[
                    {
                      name: t('settlements.table.filter'),
                      Content: () => <>
                        <Filter />
                      </>
                    },
                    {name: t('settlements.table.export')}
                  ]}
                />
              ),
              Action: ({data}) => (
                <>
                </>
              )
            }}
          />
        )
      }
    </>
  )
})



const transactions = [
  {
    name: 'Cameron Williamson',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Albert Flores',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Annette Black',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Pending',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Jacob Jones',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Guy Hawkins',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Ronald Richards',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Devon Lane',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Theresa Webb',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
  {
    name: 'Cody Fisher',
    amount: '₦853.00',
    net: '₦853.00',
    status: 'Paid',
    reference: 'theihfusbgjbsnaghas…',
    method: 'Account transfer',
    date: 'Sep 16, 2021 16:32:33pm'
  },
]